export default "__VITE_ASSET__B1N0j4HF__"